/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_NoteInputs */

const cs_enum_note = /** @type {(inputs: Enum_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poznámka`)
};

const en_enum_note = /** @type {(inputs: Enum_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note`)
};

/**
* | output |
* | --- |
* | "Note" |
*
* @param {Enum_NoteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_note = /** @type {((inputs?: Enum_NoteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_NoteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_note(inputs)
	return cs_enum_note(inputs)
});